export default __webpack_public_path__ + "static/media/studentModalStudy.fe87b139.svg";